import { render, staticRenderFns } from "./addAnnouncement.vue?vue&type=template&id=67c2e80a&scoped=true&"
import script from "./addAnnouncement.vue?vue&type=script&lang=js&"
export * from "./addAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./addAnnouncement.vue?vue&type=style&index=0&id=67c2e80a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c2e80a",
  null
  
)

export default component.exports